import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useEffect } from "react";
import axios from "axios";
import { useState } from "react";
import TablePagination from "@mui/material/TablePagination";
import {
  Box,
  Container,
  Dialog,
  DialogContent,
  Icon,
  Toolbar,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import { red, green } from "@mui/material/colors";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Edit from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

import { Link, Navigate, useNavigate, useLocation } from "react-router-dom";

// import { Leaveess } from '../Validation';
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { tableContainerStyle, tableStyle } from "../../../../utils/style";
import { Transactionondutyedity } from "../../../Validation";
import HomeIcon from "@mui/icons-material/Home";
import ComponentLoader from "../../../../ComponentLoader";

// import './App.css'

function TransactionOnduty({ head }) {
  const Navigate = useNavigate("");

  // const backButton = () => {
  //   Navigate("/");
  // };

  const nextButton = () => {
    Navigate("/TransactionTsms");
  };

  const Previousbutton = () => {
    Navigate("/transactionleave");
  };

  const ColorButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText(red[500]),
    textTransform: "none",
    backgroundColor: red[500],
    "&:hover": {
      backgroundColor: red[700],
    },
  }));

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [stateId, setStateId] = useState("");
  const [stateCode, setStateCode] = useState("");
  const [loader,setLoader] =useState(false);
  const [direct, setDirect] = useState([]);
  const [Info, setInfo] = useState([]);
  const [open, setOpen] = React.useState(false);


  const [startDate,setstartDate] = useState("")
  const [endDate,setendDate] = useState("")
  const [dutyType,setdutyType] = useState("")
  const [place,setplace] = useState("")
  const [purpose,setpurpose] = useState("")

  const [startDateErr,setstartDateErr] = useState(false)
  const [endDateErr,setendDateErr] = useState(false)
  const [dutyTypeErr,setdutyTypeErr] = useState(false)
  const [placeErr,setplaceErr] = useState(false)
  const [purposeErr,setpurposeErr] = useState(false)




  const [date, setDate] = useState("");
  const [leaveTypeId, setLeaveTypeId] = useState(null);
  // const [notes, setNotes] = useState("")

  const [reason, setReason] = useState("");
  const [rptDate, setRptDate] = useState("");

  // const [rptDate,setRptDate] =useState("")
  const [onDytyTypeId, setOnDytyTypeId] = useState("");
  const [Place, setPlace] = useState("");
  const [Notes, setNotes] = useState("");

  const [token, setToken] = useState("");
  const [id, setId] = useState(0);
  const [data, setData] = useState([]);
  const [msr, setMsr] = useState(null);
  const [leavess, setLeavess] = useState([]);

  const [dire, serDire] = useState([]);
  console.log(dire);

  const [TrnMonthlyReport, setTrnMonthlyReport] = useState();
  console.log(TrnMonthlyReport);
  const navigate = useNavigate();
  const location = useLocation();
  const [state, setState] = useState();
  const [assM, setAssMonth] = useState("");

  const [Mname, setName] = useState("");
  const [disables, setDisables] = useState(false);
  const [role, setRole] = useState("");
  const [invis, setInvestigator] = useState();

  console.log(date);
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    setValue,
    reset,
    watch,
  } = useForm({
    resolver: yupResolver(Transactionondutyedity),
  });

  const onclickDelete = async (id) => {
    const result = window.confirm("Are you sure you want to delete?");
    if (result) {
      // Perform the delete operation
      deleteTransaction(id);
      console.log("Deleted successfully");
      window.location.reload();
    } else {
      // Cancelled delete operation
      console.log("Delete cancelled");
    }
  };

  const deleteTransaction = async (id) => {
    const d = {
      Id: id,
    };
    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    try {
      const { data } = await axios.post(
        `${window.BASE}${window.TRANSONDUTYDELETE}`,
        d,
        { headers: h }
      );
      console.log(data);
    } catch (error) {
      console.log(error);
    }
  };

  const toastSuccess = (data) => {
    toast.success(data, {
      position: toast.POSITION.TOP_RIGHT,
    });
  };
  const toastError = (data) => {
    toast.error(data, {
      position: toast.POSITION.TOP_RIGHT,
    });
  };

  useEffect(() => {
    const tok = localStorage.getItem("token");
    const objectString = localStorage.getItem("MReport");
    const myObject = JSON.parse(objectString);

   
    const role = localStorage.getItem("role");
    if (role === "Investigator") {
      if (tok != null && tok != undefined) {
        setToken(tok);
        if (myObject !== null) {
          getTransactiononduty(tok, myObject.id);
          setMsr(myObject.id);
          handleTransactionondutyId(tok);
        }
      }
    } else {
      const report = JSON.parse(localStorage.getItem("FacultyAll"));
      if (report) {
        let data = report["onDuty"];
        setDirect(data);
      } else {
        setDirect([]);
      }
    }
    setRole(role);
    let dis = localStorage.getItem("disable");
    if (dis !== null) {
      setDisables(true);
    } else {
      setDisables(false);
    }
    head("Onduty Information");
  }, []);

  useEffect(() => {
    const objectString = localStorage.getItem("MReport");
    const myObject = JSON.parse(objectString);
    console.log(myObject);
    if (myObject !== null) {
      setState(myObject);
    }
    const Month = localStorage.getItem("Month");
    if (Month !== null) {
      setAssMonth(Month);
    }
    const investigator = localStorage.getItem("loginId");
    setInvestigator(investigator);
  }, []);

  //    *********************

  function createData(code, Lname, option) {
    return { code, Lname, option };
  }

  const rows = [];

  const edit = (item) => {
    console.log(item);
    setOpen(true);
    setstartDate(item.rptDate);
    setendDate(item.rptDate);
    setdutyType(item.onDytyName);
    setplace(item.place);
    setNotes(item.notes);

    setId(item.id);
  };

  const handleTransactionondutyId = async (token) => {
    console.log(token);
    setLoader(true)
    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    try {
      const { data } = await axios.get(`${window.BASE}${window.ONDUTYS}`, {
        headers: h,
      });
      console.log(data);setLoader(false)
      serDire(data);
    } catch (error) {
      console.log(error);setLoader(false)
    }
  };

  const getTransactiononduty = async (token, id) => {
    setLoader(true)
    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    try {
      const { data } = await axios.get(
        `${window.BASE}${window.TRANSACTIONONDUTYPAGE}${"/" + id}`,
        { headers: h }
      );
      console.log(data);setLoader(false)
      if (data) {
        setDirect(data);
      } else {
        toastError(data.errorMsgs);
      }
      //
    } catch (error) {
      console.log(error);setLoader(false)
    }
  };

  const reload = () => {
    window.location.reload();
  };
  /// submit button
  const leaveSubmit = async () => {
    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    const d = {
      id,
      FromDate: startDate,
      ToDate: endDate,
      OnDytyId: dutyType,
      Place: place,
      Purpose: purpose,
      // Notes: ondutynotesv,
      MRSId: state.id,
      investigatorId: parseInt(invis),
      rptMonth: parseInt(assM),
    };
    console.log(d);
    if (id === 0) {
      try {
        const { data } = await axios.post(
          `${window.BASE}${window.TRANSACTIONONDUTYEDITBUTTON}`,
          d,
          { headers: h }
        );
        console.log(data);
        if (data.result === "Success") {
          alert("Successfully Submitted");
          // reload();
          setId(0);
          setOpen(false);
          getTransactiononduty(token, msr);
        } else {
          toastError(data.errorMsgs);
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        const { data } = await axios.post(
          `${window.BASE}${window.TRANSACTIONONDUTYUPDATE}`,
          d,
          { headers: h }
        );
        console.log(data);
        if (data.result === "Success") {
          alert("Successfully updated");
          toastSuccess("Successfully updated");
          setId(0);
          setOpen(false);
          getTransactiononduty(token, msr);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setId(0);
  };

  const formValidateFun=()=>{
    if(!startDate){
      setstartDateErr(true)
      document.getElementById("startDate").focus()
    }else if(!endDate){
      setendDateErr(true)
      document.getElementById("endDate").focus()
    }else if(!dutyType){
      setdutyTypeErr(true)
      document.getElementById("dutyType").focus()
    }else if(!place){
      setplaceErr(true)
      document.getElementById("place").focus()
    }else if(!purpose){
      setpurposeErr(true)
      document.getElementById("purpose").focus()
    }else{
      leaveSubmit()
    }
  }

  return (
    <div className="main-container-margin">
      <ComponentLoader isLoading={loader} />
      <div className="master-main d-flex">
        <div className="head-icon">
          <Link to="/monthyReport">
            <HomeIcon style={{ color: "white", marginLeft: 38 }} />
          </Link>
        </div>
        <div className="master-main-span">
          <span>Tour / OnDuty</span>
        </div>
      </div>
      <div className="tables-main">
        <div style={{ marginLeft: 20 }}>
          <button className="tables-btn" onClick={Previousbutton}>
            <div className="sidebar-icon" />
            Previous
          </button>
        </div>
        <div style={{ marginRight: 20 }}>
          <button className="tables-btn" onClick={nextButton}>
            Next
            {/* FD5B14 */}
            <div className="sidebar-icon" />
          </button>
        </div>
      </div>

      <div className="table-container-grid">
        <div className="table-head">
          {/* <div>
                    <button className='top-butto' onClick={backButton} >
                        <ArrowBackIcon style={{ marginBottom: 3 }} className="sidebar-icon" />
                        Back</button>
                </div> */}
          <div>
            <button
              className="top-button"
              onClick={handleClickOpen}
              disabled={role === "Investigator" && !disables ? false : true}
            >
              + Add
            </button>
          </div>
        </div>

        <Dialog
          fullScreen={fullScreen}
          open={open}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps={{
            component: "form",
            onSubmit: handleSubmit(leaveSubmit),
          }}
        >
          <DialogTitle id="scroll-dialog-title">
            <div className="dialogueTittle">
              <div className="Dialog-head">
                <h5>Tour/On-duty meetings attended</h5>
              </div>
              <div onClick={handleClose}>
                <CloseIcon
                  style={{ marginBottom: "10", backgroundColor: "black" }}
                  className="dialogue_close_icon"
                />
              </div>
            </div>
          </DialogTitle>
          <DialogContent className="Dialog-box" style={{ padding: 0 }}>
            <div className="manu-form ">

              <div className="box width-50">
                <TextField
                  error={startDateErr}
                  fullWidth
                  id="startDate"
                  label="Start Date"
                  type="date"
                  value={startDate}
                  variant="outlined"
                  size="small"
                  onChange={(e) => {
                    setstartDate(e.target.value);
                    setstartDateErr(false);
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    placeholder: "",
                  }}
                />
              </div>

              <div className="box width-50">
                <TextField
                  error={endDateErr}
                  fullWidth
                  id="endDate"
                  label="End Date"
                  type="date"
                  variant="outlined"
                  value={endDate}
                  size="small"
                  onChange={(e) => {
                    setendDate(e.target.value);
                    setendDateErr(false);
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    placeholder: "",
                  }}
                />
              </div>

              {/* <div className="box width-50">
                <TextField
                  fullWidth
                  id="outlined-basic"
                  label="Duty Details"
                  variant="outlined"
                  size="small"
                  {...register("ondutyleavenamev")}
                  error={errors.ondutyleavenamev ? true : false}
                  helperText={errors.ondutyleavenamev?.message}
                  // select // Add 'select' to indicate that you want to create a select input
                >
                  {dire?.map((row) => (
                    <MenuItem key={row.id} value={row.id}>
                      {row.tourOrDutyName}
                    </MenuItem>
                  ))}
                </TextField>
              </div> */}

              <div className="box width-50">
                <FormControl
                  style={{ width: "100%" }}
                  error={dutyTypeErr}
                  id="dutyType"
                >
                  <InputLabel id="demo-simple-select-label">Duty Type</InputLabel>
                  <Select
                    style={{ height: "32px" }}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={dutyType}
                    label="Duty Type"
                    size="small"
                    sx={{ width: "100%" }}
                    onChange={(e) => {
                      setdutyType(e.target.value);
                      setdutyTypeErr(false);
                    }}
                  >
                    {dire?.map((row) => {
                      return <MenuItem value={row.id}>{row.tourOrDutyName}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </div>

              <div className="box width-50">
                <TextField
                  error={placeErr}
                  fullWidth
                  id="place"
                  label="Place"
                  value={place}
                  variant="outlined"
                  size="small"
                  onChange={(e) => {
                    setplace(e.target.value);
                    setplaceErr(false);
                  }}
                />
              </div>

              <div className="box width-50">
                <TextField
                  error={purposeErr}
                  fullWidth
                  id="purpose"
                  label="Purpose"
                  variant="outlined"
                  size="small"
                  value={purpose}
                  onChange={(e) => {
                    setpurpose(e.target.value);
                    setpurposeErr(false)
                  }}
                />
              </div>

              <div className="box width-50"></div>
            </div>
          </DialogContent>
          <DialogActions className="button">
            {/* <button
              variant="outlined"
              onClick={handleClose}
              style={{ backgroundColor: "#008CBA" }}
              className="btn2"
            >
              Back
            </button> */}
            <button variant="outlined" type="submit" className="btn1" onClick={formValidateFun}>
            Save
            </button>
          </DialogActions>
        </Dialog>

        {/* ************************* */}

        <TableContainer sx={tableContainerStyle}>
          <Table
            sx={tableStyle}
            aria-labelledby="tableTitle"
            stickyHeader
            aria-label="sticky table"
          >
            <TableHead className="headtable">
              <TableCell align="right">Faculty Name</TableCell>
              <TableCell align="right">Start Date</TableCell>
              <TableCell align="right">End Date</TableCell>
              <TableCell align="right">Duty Details</TableCell>
              <TableCell align="right">Place</TableCell>
              <TableCell align="right">Purpose</TableCell>
              <TableCell align="right">Option</TableCell>
            </TableHead>

            <TableBody>
              {direct?.map((row) => {
                let a = new Date(row.leaveDate).toLocaleDateString("de-DE");
                console.log(a);
                return (
                  <TableRow
                    key={row.rptDate}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell align="right">{row.investigatorName}</TableCell>
                    <TableCell align="right">{" "}{row.fromDate.substring(0, 10)}</TableCell>
                    <TableCell align="right">{" "}{row.toDate.substring(0, 10)}</TableCell>
                    <TableCell align="right">{row.tourOrDutyName}</TableCell>
                    <TableCell align="right">{row.place}</TableCell>
                    <TableCell align="right">{row.purpose}</TableCell>
                    <TableCell align="right">
                      <button
                        className="btns"
                        variant="outlined"
                        onClick={() => edit(row)}
                        disabled={
                          role === "Investigator" && !disables ? false : true
                        }
                      >
                        {<Edit className="sidebar-icon" />}
                      </button>
                      <button
                        className="deleted"
                        style={{ marginLeft: 3 }}
                        onClick={() => onclickDelete(row.id)}
                        disabled={
                          role === "Investigator" && !disables ? false : true
                        }
                      >
                        {<DeleteIcon className="sidebars-icon" />}
                      </button>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
}
export default TransactionOnduty;
